import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RunFlowsParams {
  readonly ids: string[];
}

export interface RunFlowsResult extends IResult {
}

export class RunFlowsRequest extends Request<RunFlowsParams, RunFlowsResult> {
  constructor(ids: string[]) {
    super('runFlows', { ids: ids });
  }
}


